export default __webpack_public_path__ + "static/media/hamburger.8c1fc02a.png";